<script>
export default {
  name: 'RenewSubscription',
  props: {
    expire: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      planId: process.env.VUE_APP_PAYPAL_PLAN_ID,
      style: {
        color: 'gold'
      },
      loading: false
    }
  },
  mounted() {
    this.loading = false

    const { createSubscription, onApprove, style } = this
    paypal
      .Buttons({
        createSubscription,
        onApprove,
        style
      })
      .render('#paypal-button-container')
  },
  methods: {
    createSubscription(data, actions) {
      return actions.subscription.create({
        plan_id: this.planId,
        start_time: this.expire
      })
    },
    onApprove(data, actions) {
      this.$emit('renew', data)
    }
  }
}
</script>

<template>
  <!-- <div class="subscription-modal">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Renew subscription
        </p>
      </header>
      <section class="modal-card-body">
        <div class="content">
          Your subscription expires
          <time :datetime="expire">
            {{ $moment(expire).format('DD MMMM YYYY') }} </time
          >.
          <br />
          Until then, you can still use all features. If you renew subscription,
          the fee will be charged only when this subscription expires.
        </div>
        <div id="paypal-button-container" />
      </section>
      <footer class="modal-card-footer">
        <footer class="modal-card-foot">
          <button
            class="button is-tertiary is-rounded"
            type="button"
            :disabled="loading"
            @click="$parent.close()"
          >
            Not now
          </button>
        </footer>
      </footer>
    </div>
  </div> -->
  <div id="paypal-button-container" />
</template>
